import { GraphSettings } from 'app/buffer-graph/models/graph-settings';
import { ChartData } from 'app/buffer-graph/models/chart-data';

export class GraphData {
    constructor(public readonly settings: GraphSettings, public readonly chartData: ChartData) {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/graph-data.ts